@if (!menu.hidden) {
    <div class="menu-item mb-2">
      @if (menu.items?.length) {
        <!-- Parent Menu with children -->
        <div
          class="btn d-flex align-items-center menu-item-label"
          (click)="toggleSubMenu(menu)"
          type="button"
        >
          <div class="w-100 text-start d-flex align-items-center">
            <app-icon
              [icon]="menu.icon"
              [hoverClass]="'red'"
              [color]="isActive(menu.path) ? 'red' : 'white'"
            ></app-icon>
            <div class="ms-2">{{ menu.label }}</div>
          </div>
          <div style="margin-left: auto">
            <app-icon
              [icon]="menu.expanded ? 'KEYBOARD_ARROW_UP' : 'KEYBOARD_ARROW_DOWN'"
              [hoverClass]="'red'"
              [color]="isActive(menu.path) ? 'red' : 'white'"
            ></app-icon>
          </div>
        </div>
  
        @if (menu.expanded) {
          <!-- Submenu -->
          <div class="ms-3 mt-1">
            @for (subMenu of menu.items; track $index) {
              <div class="submenu-item">
                <app-menu-item
                  [menu]="subMenu"
                  [toggleSubMenu]="toggleSubMenu"
                ></app-menu-item>
              </div>
            }
          </div>
        }
      } @else {
        <!-- Single Menu -->
        <a
          [routerLink]="menu.path"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}"
          ariaCurrentWhenActive="page"
          class="btn w-100 text-start d-flex align-items-center menu-item-label"
        >
          <app-icon
            [icon]="menu.icon"
            [hoverClass]="'red'"
            [color]="isActive(menu.path) ? 'red' : 'white'"
            [filledIcon]="true"
          ></app-icon>
          <div class="ms-2">{{ menu.label }}</div>
        </a>
      }
    </div>
  }
  